export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";